import { klaviyoAnalytics } from "../klaviyo";

export function identify(data) {
  console.log('IDENTIFY', data);
  klaviyoAnalytics("identify", null, {
    $email: data.email,
    $city: data.locale == 'fr' ? 'chapais' : ''
  });
}
